export const joinProcessBusinessTypeConstants = {
  key: '재배작물',
  values: ['대리점', '수리점', '수출업', '기타'],
  labels: [],
};
